export default __webpack_public_path__ + "static/media/airstrapz-blk-banner-2.e3f0d41e.jpg";